( function () {
	'use strict';

	/* @ngInject */
	function Observations ( $q, logger, apiService, Session, ERROR_MSGS, _ ) {
		function getCompletedObservationsByObsView () {
			return apiService.getCompletedObservationsByObsView.query( {
				'userId' : Session.getCredentials().userId
			} ).$promise;
		}

		function getCompletedObservationsByObsViewAndRevision ( theRevision ) {
			return apiService.getCompletedObservationsByObsView.query( {
				'userId'   : Session.getCredentials().userId,
				'revision' : theRevision
			} ).$promise;
		}

		function getRevisions ( templateId ) {
			return apiService.getRevisions.query( {
				'templateId'     : templateId,
				'hasObservation' : true
			} ).$promise;
		}

		function getObservations ( isAbbr ) {
			var isAbbreviated = true;

			if ( isAbbr !== undefined ) {
				isAbbreviated = isAbbr;
			}

			var credentials = Session.getCredentials();
			var deferred    = $q.defer();
			// default to in-progress observations
			var query = {
				'userId'      : credentials.userId,
				'observation' : 'observations',
				'abbrev'      : isAbbreviated,
				'partial'     : true,
				'limit'       : 10000
			};

			apiService.observation.query( query, function ( data ) {
				deferred.resolve( data || [ ] );
			}, function ( err ) {
				logger.error( ERROR_MSGS.fetchingData, err );
				deferred.reject( ERROR_MSGS.fetchingData );
			} );

			return deferred.promise;
		}

		function getObservationReport ( type, inReview ) {
			// type is for completed or in-progress observation query
			// using boolean: type===false(completed), type===true(in-progress)

			var credentials = Session.getCredentials();
			var deferred    = $q.defer();

			var query = {
				'userId'   : credentials.userId,
				'abbrev'   : false,
				'partial'  : type,
				'limit'    : 10000,
				'inReview' : inReview
			};

			apiService.getObservationReport.query( query, function ( data ) {
				deferred.resolve( data || [ ] );
			}, function ( err ) {
				logger.error( ERROR_MSGS.fetchingData, err );
				deferred.reject( ERROR_MSGS.fetchingData );
			} );

			return deferred.promise;
		}

		function getSchoolName ( id ) {
			var deferred = $q.defer();

			apiService.getHierarchy.get( {
				'id' : id
			}, function ( data ) {
				deferred.resolve( data || { } );
			}, function ( err ) {
				logger.error( ERROR_MSGS.fetchingData, err );
				deferred.reject( ERROR_MSGS.fetchingData );
			} );

			return deferred.promise;
		}

		function getUserEvents () {
			var credentials = Session.getCredentials();
			var deferred    = $q.defer();

			var query = {
				'userId' : credentials.userId
			};

			apiService.userEvents.query( query, function ( data ) {
				var events = data;

				deferred.resolve( events );
			}, function ( err ) {
				logger.error( ERROR_MSGS.fetchingData, err );
				deferred.reject( ERROR_MSGS.fetchingData );
			} );

			return deferred.promise;
		}

		function getObservationsByUser ( customQuery ) {
			var query = {
				'abbrev' : false,
				'limit'  : 10000
			};

			_.extend( query, customQuery );

			return apiService.getObservationsByUser.query( query, {
				'userId' : Session.getCredentials().userId
			} ).$promise;
		}

		var service = {
			'getObservations'                              : getObservations,
			'getCompletedObservationsByObsView'            : getCompletedObservationsByObsView,
			'getCompletedObservationsByObsViewAndRevision' : getCompletedObservationsByObsViewAndRevision,
			'getRevisions'                                 : getRevisions,
			'getUserEvents'                                : getUserEvents,
			'getObservationReport'                         : getObservationReport,
			'getSchoolName'                                : getSchoolName,
			'getObservationsByUser'                        : getObservationsByUser
		};

		return service;
	}

	angular
		.module( 'app.core' )
		.factory( 'observationsApi', Observations );
} )();
